import * as moment from 'moment';
import { LegacyAuthorization, PatientAuthorization } from '../services/patient-authorization.service';

export const AUTHORISATION_STATUS_LABELS: Record<PatientAuthorization['status'], string> = {
  requested: 'Requested',
  approved: 'Approved',
  declined: 'Declined',
  expired: 'Expired',
};

const day = (value: string) => moment(value).format('DD/MM/YYYY');

/** "01/10/2026 – 31/10/2026", "01/10/2026 + 3 day(s)", "from …", "until …", or '' when no dates were given. */
export function authorisationValidity(a: Pick<PatientAuthorization, 'authorisedFrom' | 'authorisedTo' | 'authorisedDays'>): string {
  const from = a?.authorisedFrom ? day(a.authorisedFrom) : '';
  const to = a?.authorisedTo ? day(a.authorisedTo) : '';
  if (from && to) return `${from} – ${to}`;
  if (from && a.authorisedDays) return `${from} + ${a.authorisedDays} day(s)`;
  if (from) return `from ${from}`;
  if (to) return `until ${to}`;
  return '';
}

/**
 * One line per authorisation for the patient file's summary card, newest first: recorded authorisations
 * (number, status, validity, scheme) and numbers still stored on the patient or admission record.
 */
export function authorisationLines(recorded: PatientAuthorization[] | null, stored: LegacyAuthorization[] | null): string[] {
  const rows = [
    ...(recorded || []).filter(a => a.active !== false).map(a => ({
      when: a.authorisedFrom || a.createdAt || '',
      parts: [a.authNumber, AUTHORISATION_STATUS_LABELS[a.status], authorisationValidity(a), a.schemeName],
    })),
    ...(stored || []).map(s => ({
      when: s.date || '',
      parts: [s.authNumber, s.date ? `from ${day(s.date)}` : ''],
    })),
  ];
  return rows
    .sort((x, y) => (y.when ? moment(y.when).valueOf() : 0) - (x.when ? moment(x.when).valueOf() : 0))
    .map(r => r.parts.filter(Boolean).join(' · '));
}
